import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class WorkingPlatform extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            values,
            protocol,
            classes,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item>
                    <Grid container spacing={8} alignItems="center">
                        <Grid item xs={3}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Gerüstnummer:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="scaffold_number"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.scaffold_number}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Gerüstbreite (mm):
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="number"
                                name="scaffold_width"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.scaffold_width}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Standort:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="scaffold_location"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.scaffold_location}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Gerüstlänge (mm):
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="number"
                                name="scaffold_length"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.scaffold_length}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Händler/Hersteller:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Plattformhöhe (mm):
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="number"
                                name="platform_height"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.platform_height}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Artikel Nr./Typ Nr.:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="item_number"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.item_number}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container justify="center" alignItems="center">
                        <Grid item xs={4}>
                            <Typography component={"div"} align={"left"}
                                        variant={"subtitle1"}>
                                Prüfkriterium
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                        </Grid>
                        <Grid item xs={5}>
                            <Typography component={"div"} align={"center"}
                                        variant={"subtitle1"}>
                                Bemerkungen
                            </Typography>
                        </Grid>

                        {/*#################################################*/}

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Aufsteckrahmen:
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Verformung/Abnutzung
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="deformation_frame"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.deformation_frame || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="deformation_frame_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deformation_frame_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Beschädigung/Risse
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="damage_frame"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.damage_frame || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="damage_frame_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.damage_frame_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                scharfe Kanten, Splitter, Grate
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="sharp_edges_frame"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.sharp_edges_frame || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="sharp_edges_frame_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sharp_edges_frame_annotation}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>

                        {/*#################################################*/}

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Streben/Horizontal Diagonalen:
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Verformung/Abnutzung
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="deformation_bar"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.deformation_bar || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="deformation_bar_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deformation_bar_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Beschädigung/Risse
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="damage_bar"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.damage_bar || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="damage_bar_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.damage_bar_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                scharfe Kanten, Splitter, Grate
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="sharp_edges_bar"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.sharp_edges_bar || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="sharp_edges_bar_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sharp_edges_bar_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Funktion der Schnellverschlüsse
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="quick_fastener_bar"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.quick_fastener_bar || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="quick_fastener_bar_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.quick_fastener_bar_annotation}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>

                        {/*#################################################*/}

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Geländer:
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Verformung/Abnutzung
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="deformation_railing"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.deformation_railing || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="deformation_railing_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deformation_railing_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Beschädigung/Risse
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="damage_railing"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.damage_railing || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="damage_railing_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.damage_railing_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                scharfe Kanten, Splitter, Grate
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="sharp_edges_railing"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.sharp_edges_railing || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="sharp_edges_railing_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sharp_edges_railing_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Funktion der Schnellverschlüsse
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="quick_fastener_railing"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.quick_fastener_railing || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="quick_fastener_railing_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.quick_fastener_railing_annotation}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>

                        {/*#################################################*/}

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Plattform:
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Verformung/Abnutzung
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="deformation_platform"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.deformation_platform || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="deformation_platform_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deformation_platform_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Beschädigung/Risse
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="damage_platform"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.damage_platform || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="damage_platform_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.damage_platform_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                scharfe Kanten, Splitter, Grate
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="sharp_edges_platform"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.sharp_edges_platform || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="sharp_edges_platform_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sharp_edges_platform_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Funktion der Schnellverschlüsse
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="quick_fastener_platform"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.quick_fastener_platform || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="quick_fastener_platform_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.quick_fastener_platform_annotation}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>

                        {/*#################################################*/}

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Bordbretter:
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Zustand des Holzes
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="status_plank"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.status_plank || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="status_plank_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.status_plank_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Abnutzung/Beschädigung
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="damage_plank"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.damage_plank || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="damage_plank_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.damage_plank_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                scharfe Kanten, Splitter, Grate
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="sharp_edges_plank"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.sharp_edges_plank || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="sharp_edges_plank_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sharp_edges_plank_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Funktionsfähigkeit
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="quick_fastener_plank"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.quick_fastener_plank || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="quick_fastener_plank_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.quick_fastener_plank_annotation}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>

                        {/*#################################################*/}

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Fahrbalken/Ausleger:
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Verformung/Abnutzung
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="deformation_jib"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.deformation_jib || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="deformation_jib_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deformation_jib_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Beschädigung/Risse
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="damage_jib"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.damage_jib || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="damage_jib_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.damage_jib_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                scharfe Kanten, Splitter, Grate
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="sharp_edges_jib"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.sharp_edges_jib || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="sharp_edges_jib_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sharp_edges_jib_annotation}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>

                        {/*#################################################*/}

                        <Grid item xs={12}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Lenkrollen:
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Abnutzung/Beschädigung
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="deformation_castor"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.deformation_castor || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="deformation_castor_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.deformation_castor_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Funktionsfähigkeit der Rollen
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="rollers_castor"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.rollers_castor || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="rollers_castor_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.rollers_castor_annotation}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Funktionsfähigkeit der Bremsen
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="brakes_castor"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.brakes_castor || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="brakes_castor_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.brakes_castor_annotation}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>

                        {/*#################################################*/}

                        <Grid item xs={4}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                Kontrollergebnis zu Zeitpunkt der Prüfung:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormRadio
                                name="result"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'n.i.O.'
                                    },
                                    {
                                        value : 'not_checked',
                                        label : 'nicht geprüft'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                onBlur={handleBlur}
                                value={values.result || ''}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormField
                                type="text"
                                name="result_annotation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.result_annotation}
                            />
                        </Grid>

                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <FormRadio
                        name="inspection_tag"
                        options={[
                            {
                                value : 'yes',
                                label : 'Prüfplakette erteilt',
                            },
                            {
                                value : 'no',
                                label : 'Prüfplakette nicht erteilt',
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.inspection_tag}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textRight: {
        textAlign: "right",
    },
    formRadio: {
        flexDirection: "row",
        marginLeft: '100px',
    },
    formRadioSelection: {
        flexDirection: "row",
        marginLeft: '-65px'
    },
    formButton: {
    },
    formSelection: {
        marginLeft: '65px'
    }
});

export default withStyles(styles)(WorkingPlatform)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/WorkingPlatform.js